import React from 'react';
import { Paper, Box, useTheme, useMediaQuery } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import Logo from './Logo';

export const DevisePage = ({ children, title, footer, maxPaperWidth }) => {
  const theme = useTheme();
  const smallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <Box
        sx={{
          outline: 'solid 1px red',
          height: '100vh',
          width: '100vw',
          overflow: 'hidden',
          backgroundColor: 'white',
        }}
      >
        <Box
          sx={{
            outline: 'solid 1px blue',
            height: '100%',
            width: '100%',
            overflowY: 'auto',
            overflowX: 'hidden',
          }}
        >
          <Box
            style={{
              marginTop: smallScreen ? 65 : 120,
              marginBottom: smallScreen ? 56 : 60,
            }}
          >
            <Logo />
          </Box>

          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Paper
              sx={{
                maxWidth: maxPaperWidth ?? 540,
                padding: '20px',
                boxShadow: '0px 1px 40px rgba(0, 0, 0, 0.05)',
              }}
            >
              {children}
            </Paper>
          </Box>

          {footer && <Box sx={{ marginBottom: 200 }}>{footer}</Box>}
        </Box>
      </Box>
    </>
  );
};
